import {
    BaseCollectionModel,
    SearchModel, yascCreateEntityApiRoutesV3,
    YascEntityApiAdapterV3,
    YascEntityApiRoutesV3
} from '@yasc/yasc-material-components';
import {RoleCreateReq, RoleMinRes, RoleRes, RoleUpdateReq} from '../../../../contracts/v0/cp/role.contract';
import {Observable} from "rxjs";
import {ApiV0Crm} from '../api.v0.crm';
import {RestApiService} from '../../../rest-api.service';
import {ApiV0} from '../../api.v0';
import {ApiV0Administration} from '../api.v0.administration';

export class ApiV0AdminRoleV3 implements YascEntityApiAdapterV3<RoleMinRes, RoleRes, RoleCreateReq, RoleUpdateReq, number> {
    readonly modelTypes = {
        row: RoleMinRes,
        detail: RoleRes,
        create: RoleCreateReq,
        update: RoleUpdateReq,
    }
    readonly idKey = 'id' as const;
    readonly segment:string;
    readonly routes:YascEntityApiRoutesV3<number>

    constructor(v0: ApiV0Administration, private readonly rest:RestApiService) {
        this.segment = v0.segment+'/roles';
        this.routes = yascCreateEntityApiRoutesV3<number>(this.segment);
    }
    search(search?: SearchModel): Observable<BaseCollectionModel<RoleMinRes, undefined, undefined>> {
        return this.rest.post<SearchModel, BaseCollectionModel<RoleMinRes>>(this.segment + '/search', RoleMinRes, search);
    }
    detail(id: number): Observable<RoleRes> {
        return this.rest.get<RoleRes>(this.routes.details(id), RoleRes);
    }
    create?(request: RoleCreateReq): Observable<RoleRes> {
        return this.rest.post<RoleCreateReq, RoleRes>(this.routes.base, RoleRes, request);
    }
    patch?(id: number, request: RoleUpdateReq): Observable<RoleRes> {
        return this.rest.patch<RoleUpdateReq, RoleRes>(this.routes.details(id), RoleRes, request);
    }
    delete?(ids: (string | number)[]): Observable<void> {
        throw new Error("Method not implemented.");
    }
}